import React from "react";
import {
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Switch,
  FormControlLabel,
} from "@mui/material";

import { formatData } from "../../../../../services/BackendServices";
import CustomIOSSwitch from "../../../../../services/iosSwitch";
// Tab 5: Pricing/Payment/Guarantee
const PricingPaymentTab = ({
  priceOffered,
  setPriceOffered,
  currency,
  setCurrency,
  paymentTermMaster,
  preferredPaymentMethod,
  setPreferredPaymentMethod,
  paymentTimeline,
  setPaymentTimeline,
  specialInstructionsSuppliers,
  setSpecialInstructionsSuppliers,
  qualityInspectionRequired,
  setQualityInspectionRequired,
  requiredSupplierCertifications,
  setRequiredSupplierCertifications,
  comparisonCriteriaPriority,
  setComparisonCriteriaPriority,
  errors,
  isViewMode,
}) => {

  return (
    <div className="row g-3">
      <div className="col-md-6">
        <Typography variant="body2">Price Offered (per MT) *</Typography>
        <TextField
          type="number"
          step="any"
          value={!isViewMode ? priceOffered : formatData(priceOffered)}
          onChange={(e) => !isViewMode && setPriceOffered(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          placeholder="Enter price per metric ton"
          error={!!errors.priceOffered}
          helperText={errors.priceOffered}
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Currency</Typography>
          <TextField
            value="USD"
            sx={{ backgroundColor: "white", width: "100%" }}
            disabled
            InputProps={{
              readOnly: true,
            }}
          />
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Preferred Payment Method</Typography>
          <Select
            value={preferredPaymentMethod}
            onChange={(e) =>
              !isViewMode && setPreferredPaymentMethod(e.target.value)
            }
            displayEmpty
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            <MenuItem value="">Select Payment Method</MenuItem>
            {paymentTermMaster.map((option, index) => (
              <MenuItem key={index} value={option.Value}>
                {option.Value}
              </MenuItem>
            ))}

          </Select>
        </FormControl>
      </div>
      <div className="col-md-6">
        <Typography variant="body2">Payment Timeline</Typography>
        <TextField
          value={paymentTimeline}
          onChange={(e) => !isViewMode && setPaymentTimeline(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          placeholder="e.g., 30 days after shipment"
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-6">
        <Typography variant="body2" sx={{ mb: 1 }}>
          Quality Inspection Required
        </Typography>
        <FormControlLabel
          control={
            <CustomIOSSwitch
              checked={qualityInspectionRequired === 1}
              onChange={(e) =>
                !isViewMode &&
                setQualityInspectionRequired(e.target.checked ? 1 : 0)
              }
              
              disabled={isViewMode}
              sx={{ m: 1 }} />
            // <Switch
            //   checked={qualityInspectionRequired === 1}
            //   onChange={(e) =>
            //     !isViewMode &&
            //     setQualityInspectionRequired(e.target.checked ? 1 : 0)
            //   }
            //   disabled={isViewMode}
            //   size="large"
            //   sx={{
            //     "& .MuiSwitch-switchBase": {
            //       "&.Mui-checked": {
            //         color: "#de6b14",
            //       },
            //       "&.Mui-checked + .MuiSwitch-track": {
            //         backgroundColor: "#de6b14",
            //       },
            //     },
            //     "& .MuiSwitch-track": {
            //       backgroundColor: "#ccc",
            //     },
            //   }}
            // />
          }
          label={qualityInspectionRequired === 1 ? "Yes" : "No"}
          labelPlacement="end"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "1.1rem",
              fontWeight: 500,
              ml: 1,
            },
          }}
        />
      </div>
      <div className="col-md-6">
        <Typography variant="body2" sx={{ mb: 1 }}>
          Required Supplier Certifications
        </Typography>
        <FormControlLabel
          control={
            <CustomIOSSwitch
             checked={requiredSupplierCertifications === 1}
              onChange={(e) =>
                !isViewMode &&
                setRequiredSupplierCertifications(e.target.checked ? 1 : 0)
              }
             
              disabled={isViewMode}
              sx={{ m: 1 }} />
            // <Switch
            //   checked={requiredSupplierCertifications === 1}
            //   onChange={(e) =>
            //     !isViewMode &&
            //     setRequiredSupplierCertifications(e.target.checked ? 1 : 0)
            //   }
            //   disabled={isViewMode}
            //   size="large"
            //   sx={{
            //     "& .MuiSwitch-switchBase": {
            //       "&.Mui-checked": {
            //         color: "#de6b14",
            //       },
            //       "&.Mui-checked + .MuiSwitch-track": {
            //         backgroundColor: "#de6b14",
            //       },
            //     },
            //     "& .MuiSwitch-track": {
            //       backgroundColor: "#ccc",
            //     },
            //   }}
            // />
          }
          label={requiredSupplierCertifications === 1 ? "Yes" : "No"}
          labelPlacement="end"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "1.1rem",
              fontWeight: 500,
              ml: 1,
            },
          }}
        />
      </div>
      <div className="col-md-12">
        <Typography variant="body2">
          Special Instructions for Suppliers
        </Typography>
        <TextareaAutosize
          value={specialInstructionsSuppliers}
          onChange={(e) =>
            !isViewMode && setSpecialInstructionsSuppliers(e.target.value)
          }
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter special instructions for suppliers"
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-12">
        <Typography variant="body2">Comparison Criteria Priority</Typography>
        <FormControl sx={{ minWidth: "100%" }}>
          <Select
            multiple
            value={comparisonCriteriaPriority}
            onChange={(e) =>
              !isViewMode && setComparisonCriteriaPriority(e.target.value)
            }
            input={<OutlinedInput />}
            renderValue={(selected) => selected.join(", ")}
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            {[
              "Price",
              "Delivery Time",
              "Quality / Product Specifications Compliance",
              "Payment Terms",
              "Supplier Reputation / Track Record",
              "Quality Certifications",
            ].map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox
                  checked={comparisonCriteriaPriority.indexOf(option) > -1}
                />
                <ListItemText primary={option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
export default PricingPaymentTab;